const allRoutes = {
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  dashboard: '/dashboard',
  overview: '/overview',
  attendance: '/attendance',
  leaveManagement: '/leave-management',
  leaveDetails: (id) => `/employee-leave-details/${id}`,
  attendanceVehicle: (id, name, type) => `/attendance/${id}/${name}/${type}`,
  attendanceVehicleWithAttnId: (id, aId, name, type) => `/attendance/${id}/${aId}/${name}/${type}`,
  attendanceOld: '/attendance-old',
  rateManagement: '/rate-management',
  addRateManagement: '/rate-management/add',
  editRateManagement: (id) => `/rate-management/edit/${id}`,
  cloneRateManagement: (id) => `/rate-management/clone/${id}`,
  worksiteLogs: '/worksite-logs',
  manageTrips: '/manage-trip',
  employeeDetails: '/employee-details-others',
  employeeDetailsDrivers: '/employee-details-drivers',
  addDrivers: '/employee-details-drivers/add',
  addManpower: '/employee-details-others/add',
  manpowerDriverDetails: (id) => `/employee-details-drivers/details/${id}`,
  manpowerOtherDetails: (id) => `/employee-details-others/details/${id}`,
  editManpower: (id) => `/employee-details-others/edit/${id}`,
  editDrivers: (id) => `/employee-details-drivers/edit/${id}`,
  vehicle: '/vehicle',
  addVehicle: '/vehicle/add',
  editVehicle: (id) => `/vehicle/edit/${id}`,
  vehicalType: '/vehicle-types',
  addVehicalType: '/vehicle-types/add',
  editVehicleType: (id) => `/vehicle-types/edit/${id}`,
  renewals: (type) => `/renewals/${type}`,
  settings: '/settings',
  password: '/password',
  manageWorksiteSetting: '/manage-worksite-setting',
  addWorksiteSetting: '/manage-worksite-setting/add',
  editWorksiteSetting: (id) => `/manage-worksite-setting/edit/${id}`,
  manageCompany: '/manage-company',
  addCompany: '/manage-company/add',
  editCompany: (id) => `/manage-company/edit/${id}`,
  manageCompetitors: '/manage-competitors',
  addCompetitor: '/manage-competitors/add',
  editCompetitor: (id) => `/manage-competitors/edit/${id}`,
  staff: '/staff',
  addStaff: '/staff/add',
  editStaff: (id) => `/staff/edit/${id}`,
  roles: '/roles',
  addRoles: '/roles/add',
  editRoles: (id) => `/roles/edit/${id}`,
  configuration: '/configuration',
  operational: '/operational',
  documentDirectory: '/operational/document-directory',
  addDocumentDirectory: '/operational/document-directory/add',
  editDocumentDirectory: (id) => `/operational/document-directory/edit/${id}`,
  competitorsData: '/add-competitors-data',
  hsdConsumption: '/operational/hsd-consumption',
  lubesConsumption: '/operational/lubes-consumption',
  vendor: '/vendor',
  addVendor: '/vendor/add/',
  editVendor: (id) => `/vendor/edit/${id}`,
  // Stores Consumed Routes
  // storesConsumed: '/stores-consumed',
  stores: '/stores',
  storesConsumedTippers: '/stores-consumed-tippers',
  storesConsumedPayloaders: '/stores-consumed-payloaders',
  storesConsumedAllOthers: '/stores-consumed-other',
  storeTipperNo: '/stores-consumed-tippers/tipper-no',
  storePayloaderNo: '/stores-consumed-payloaders/payloader-no',
  storesAllOthersNo: '/stores-consumed-all-others/other-no',
  // Add Inverter Routes Here
  inventoryCategory: '/inventory-category',
  addInventoryCategory: '/inventory-category/add',
  editInventoryCategory: (id) => `/inventory-category/edit/${id}`,
  // Add Product Management
  productManagement: '/product-management',
  addProductManagement: '/product-management/add',
  editProductManagement: (id) => `/product-management/edit/${id}`,
  purchaseOrder: '/purchase-order',
  addPurchaseOrder: '/purchase-order/add',
  viewPurchaseOrder: (id) => `/purchase-order/view/${id}`,
  receviedPurchaseOrder: (id) => `/purchase-order/received-order/${id}`,
  editPurchaseOrder: (id) => `/purchase-order/edit/${id}`,
  inventoryManagement: '/inventory-management',
  addInventoryManagement: '/inventory-management/add',
  editInventoryManagement: (id) => `/inventory-management/edit/${id}`,
  vehicleServiceLog: '/vehicle-service-log',
  workshop: '/workshop',
  workshopVehicleDetails: (id) => `/vehicle-service-log/view/${id}`,
  storeRecieved: '/stock-recieved',
  storeIssue: '/stock-issue',
  storeReturned: '/stock-returned',
  partIssue: '/inventory-management/part-issue',
  scrapPartIssue: '/inventory-management/scrap-part-issue',
  // Add Designation
  designationManagement: '/designation-management',
  addDesignation: '/designation-management/add',
  editDesignation: (id) => `/designation-management/edit/${id}`,
  designationCategory: '/designation-category',
  addDesignationCat: '/designation-category/add',
  editDesignationCat: (id) => `/designation-category/edit/${id}`,
  reports: '/reports',
  reporttbl: (id) => `/reports-details/${id}`,
  dashboardProduction: '/production',
  dashboardStats: '/statistics',
  dashboardCompetitorsStats: '/competitors-stats',
  mainDashboard: '/main-dashboard',
  keyMetrics: '/key-metrics',
  operations: '/operations',
  operationsCompetitorsStats: '/operations/competitors-stats',
  productionData: '/production-data',
  productionTippers: '/production-tippers',
  tipperNo: '/tipper-no',
  productionPayloaders: '/production-payloaders',
  payloaderNo: '/payloader-no',
  manpowerDeployment: '/manpower-deployment',
  equipment: '/equipment',
  equipmentRenewals: '/equipment-renewals',
  renewalsInsurance: '/renewals/insurance',
  renewalsFitness: '/renewals/fitness',
  renewalsPUC: '/renewals/puc',
  renewalsPermit: '/renewals/permit',
  hrAdminRenewals: '/hr-admin-renewals',
  renewalsDL: '/renewals/dl',
  renewalsVTC: '/renewals/vtc',
  renewalsIME: '/renewals/ime',
  vehicalDetail: '/vehical-detail'
}
export default allRoutes
